import { render, staticRenderFns } from "./Otoscopy.vue?vue&type=template&id=f6afba80&"
import script from "./Otoscopy.vue?vue&type=script&lang=js&"
export * from "./Otoscopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports